/**
 * i2i「跟随原图」比例实测映射 — 2026-07-13。
 *
 * 修「图改图不管上传什么比例都出 1:1」:此前「跟随原图」只是 UI 文案,提交的仍是
 * form.ratio 默认 1:1,全链路无一处量过参考图宽高。本模块把实测宽高按 log 距离就近
 * 映射到 5 档 Ratio(镜像 ai-service `app/modules/poster/domain/source_ratio.py`,
 * 两端同规则防漂移),选图后回填 form.ratio;用户手选仍最高优先。
 */
import type { Ratio } from "./useFreeCreateForm";

const CANDIDATES: ReadonlyArray<[Ratio, number]> = [
  ["1:1", 1],
  ["9:16", 9 / 16],
  ["16:9", 16 / 9],
  ["3:4", 3 / 4],
  ["4:5", 4 / 5],
];

/** 实测宽高 → 最近的 5 档 poster ratio;宽高非法(≤0/NaN)返 null,调用方不覆盖。 */
export function nearestRatio(width: number, height: number): Ratio | null {
  if (!Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) {
    return null;
  }
  const actual = Math.log(width / height);
  let best: Ratio = "1:1";
  let bestDist = Number.POSITIVE_INFINITY;
  for (const [ratio, value] of CANDIDATES) {
    const dist = Math.abs(Math.log(value) - actual);
    if (dist < bestDist) {
      bestDist = dist;
      best = ratio;
    }
  }
  return best;
}

/** 从图片 File 读实测宽高(objectURL + Image 解码);解码失败返 null。 */
export function measureImageFile(file: File): Promise<{ width: number; height: number } | null> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
}
